import { Job, JobKinds } from '../types/job';
import { School } from '../types/school';

/** Initiative applications have no job posting, so their job stub has no id. */
export function isInitiativeJob(
  job: Pick<Job, 'id'> | null | undefined
): boolean {
  return !job?.id;
}

/**
 * Job stand-in for an initiative application: carries only the school or
 * authority it went to, so cards, breadcrumbs and profile links still work.
 */
export function initiativeJob(
  schoolId: string | null,
  schoolAuthorityId: string | null,
  owner: School | null
): Job {
  return {
    id: '',
    schoolId: schoolId ?? '',
    schoolRootId: owner?.rootId ?? schoolId ?? '',
    schoolAuthorityId,
    ownerType: schoolId ? 'school' : 'school_authority',
    schoolName: owner?.name ?? '',
    schoolTitle: '',
    schoolAvatar: owner?.avatar ?? null,
    schoolAddress: owner?.address ?? null,
    title: '',
    function: '',
    kind: JobKinds.PERMANENT,
    isFullTimeJob: false,
  } as unknown as Job;
}
